// Product Card Urgency Bar - live stock polling
// Re-fetches the sections containing urgency bars via the Section Rendering
// API and syncs level class, text and bar width. Shopify's page cache holds
// rendered sections for up to ~2 minutes after an inventory change;
// If-None-Match returns an empty 304 while the cached copy is unchanged,
// which keeps polls cheap.
(function() {
    'use strict';

    var POLL_INTERVAL = 30000;
    var MAX_SECTIONS = 3;
    var LEVELS = ['low', 'medium', 'high'];
    var sectionEtags = {};
    var inFlight = {};
    var tickOffset = 0;

    function applyFresh(liveEl, freshEl) {
        // Un-hide first (the bar may have been hidden on an earlier tick) so
        // the bar below can be measured while it is laid out
        liveEl.style.display = '';

        var liveBar = liveEl.querySelector('.product-card-urgency--bar');
        var freshBar = freshEl.querySelector('.product-card-urgency--bar');

        // Hand the bar from the load keyframe over to the is-live transition
        // before anything else changes. Cancelling the keyframe collapses the
        // transition start value to the base width of 0, so pin the width it
        // painted and flush that - while the old level colour is still on, or
        // the flush would swallow the colour cross-fade as well.
        if (liveBar && !liveBar.classList.contains('is-live')) {
            liveBar.style.width = window.getComputedStyle(liveBar).width;
            liveBar.style.animation = 'none';
            void liveBar.offsetWidth;
            liveBar.classList.add('is-live');
        }

        // (a) Sync level modifier class
        for (var i = 0; i < LEVELS.length; i++) {
            var cls = 'product-card-urgency--' + LEVELS[i];
            liveEl.classList.toggle(cls, freshEl.classList.contains(cls));
        }

        // (b) Replace text
        var liveText = liveEl.querySelector('.product-card-urgency--text');
        var freshText = freshEl.querySelector('.product-card-urgency--text');
        if (liveText && freshText) {
            liveText.textContent = freshText.textContent;
        }

        // (c) Animate bar to the fresh width - level class and width change in
        // the same frame, so width and background-color cross-fade together
        var width = freshBar ? freshBar.style.getPropertyValue('--urgency-width') : '';
        if (liveBar && width) {
            liveBar.style.width = width;
        }
    }

    function pollSection(sectionId, liveEls) {
        if (inFlight[sectionId]) return;
        inFlight[sectionId] = true;

        var headers = {};
        if (sectionEtags[sectionId]) {
            headers['If-None-Match'] = sectionEtags[sectionId];
        }

        // Keep the current query string (collection filters, search terms)
        var params = new URLSearchParams(window.location.search);
        params.set('section_id', sectionId);

        fetch(window.location.pathname + '?' + params.toString(), { headers: headers })
            .then(function(response) {
                if (response.status !== 200) return null;
                sectionEtags[sectionId] = response.headers.get('etag');
                return response.text();
            })
            .then(function(html) {
                if (!html) return;

                var doc = new DOMParser().parseFromString(html, 'text/html');
                var freshById = {};
                var docRenderedAt = 0;

                // Take the render timestamp from the cards, not from the bars:
                // once the last remaining product sells out the section renders
                // zero bars, and a timestamp of 0 would leave every stale bar
                // below on screen forever
                var freshCards = doc.querySelectorAll('product-card[data-rendered-at]');
                for (var c = 0; c < freshCards.length; c++) {
                    var cardTs = parseInt(freshCards[c].dataset.renderedAt) || 0;
                    if (cardTs > docRenderedAt) docRenderedAt = cardTs;
                }

                var freshEls = doc.querySelectorAll('.product-card-urgency[data-product-id]');
                for (var i = 0; i < freshEls.length; i++) {
                    freshById[freshEls[i].dataset.productId] = freshEls[i];
                    var ts = parseInt(freshEls[i].dataset.renderedAt) || 0;
                    if (ts > docRenderedAt) docRenderedAt = ts;
                }

                for (var j = 0; j < liveEls.length; j++) {
                    var productId = liveEls[j].dataset.productId;
                    // Shopify's page cache runs on several shards holding
                    // copies of different age - only ever apply a copy newer
                    // than what is shown
                    var liveTs = parseInt(liveEls[j].dataset.renderedAt) || 0;
                    var fresh = freshById[productId];
                    if (fresh) {
                        var freshTs = parseInt(fresh.dataset.renderedAt) || 0;
                        if (freshTs > liveTs) {
                            applyFresh(liveEls[j], fresh);
                            liveEls[j].dataset.renderedAt = String(freshTs);
                        }
                    } else if (docRenderedAt > liveTs && !liveEls[j].closest('[data-paginated]')) {
                        // No bar in a newer render of the same result set: the
                        // product sold out, urgency was switched off, or it
                        // dropped out of the results entirely - the bar is
                        // stale either way. Cards appended by infinite scroll
                        // are exempt: they belong to a later page and never
                        // appear in this render.
                        liveEls[j].style.display = 'none';
                        liveEls[j].dataset.renderedAt = String(docRenderedAt);
                    }
                }
            })
            .catch(function() {})
            .then(function() {
                inFlight[sectionId] = false;
            });
    }

    function tick() {
        if (document.hidden) return;

        // Stateless scan: group live bars by their surrounding section
        var bars = document.querySelectorAll('.product-card-urgency[data-product-id]');
        var groups = {};
        var order = [];

        for (var i = 0; i < bars.length; i++) {
            // Skip AJAX-filled hosts: their cards never appear in a plain
            // ?section_id= render, so polling them is useless
            if (bars[i].closest('product-recommendations, recently-viewed-products')) continue;
            var section = bars[i].closest('.shopify-section');
            if (!section || !section.id) continue;
            var sectionId = section.id.replace(/^shopify-section-/, '');
            if (!groups[sectionId]) {
                groups[sectionId] = [];
                order.push(sectionId);
            }
            groups[sectionId].push(bars[i]);
        }

        // Round-robin across ticks so pages with more sections than the
        // per-tick cap still update every section eventually
        var count = Math.min(order.length, MAX_SECTIONS);
        for (var j = 0; j < count; j++) {
            var id = order[(tickOffset + j) % order.length];
            pollSection(id, groups[id]);
        }
        tickOffset = count ? (tickOffset + count) % order.length : 0;
    }

    function init() {
        // No bar guard: bars can appear later (AJAX facet changes replace
        // the grid); tick() performs no fetches when none are present
        setInterval(tick, POLL_INTERVAL);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
